import instance from "./axios";
import baseUrl from "@/env";

export async function getBookUserStatus() {
  const res = await instance.get(`${baseUrl}/app/book-user/status`);
  return res.data;
}

export async function campusAuthBookUser(data) {
  const res = await instance.post(`${baseUrl}/app/book-user/campus-auth`, data);
  return res.data;
}
